import {
  API_KEYS_SUCCESS,
  API_KEYS_CREATE,
  API_KEYS_DELETE,
} from '../constants/actions';

const initialState = {
  isFetching: false,
  hasFetched: false,
  data: [],
  newToken: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case API_KEYS_SUCCESS:
      return {
        ...state,
        data: action.data,
      };

    case API_KEYS_CREATE:
      return {
        ...state,
        newToken: action.token,
      };

    case API_KEYS_DELETE:
      return {
        ...state,
        data: state.data.filter((k) => k.token_hmac !== action.data),
      };

    default:
      return { ...state };
  }
};
